import { useLayoutEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAuthEmail } from "./handlers";

export default function ResetPwdEmailPage() {
  const { t } = useTranslation();

  const txtRef = useRef<HTMLHeadingElement | null>(null);

  const { onAuthEmail } = useAuthEmail();

  useLayoutEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = t("eml_auth_text_1_join");
    }
  }, [t]);
  return (
    <>
      <div className="_inner">
        <h2>{t("eml_auth_join")}</h2>
        <div className="leading-[28px]">
          <h4 ref={txtRef} />
        </div>
        <div className="flex justify-center pt-[40px]">
          <button className="btn bg-red-400 px-2" onClick={onAuthEmail}>
            {t("btn_eml_auth")}
          </button>
        </div>
      </div>
    </>
  );
}
